
export const fetchWithTimeout = async (input, options = {}, timeout = 5000) => {
  const timeoutSignal = AbortSignal.timeout(timeout);
  const signal = options.signal 
    ? AbortSignal.any([options.signal, timeoutSignal])
    : timeoutSignal;
  return fetch(input, {
    ...options,
    signal,
  });
};

export const fetchJson = async (input, options = {}, timeout = 5000) => {
  const timeoutSignal = AbortSignal.timeout(timeout);
  const signal = options.signal 
    ? AbortSignal.any([options.signal, timeoutSignal])
    : timeoutSignal;
  const response = await fetchWithTimeout(input, {
    ...options,
    signal,
  });
  if (!response.ok) {
    throw new Error(`Server error: ${response.status}`);
  }
  try {
    return await response.json();
  } catch (e) {
    console.error(e);
    throw new Error(`Failed to parse JSON response from ${input}`);
  }
};

export const rpc = async ({method, params, setErrorMessage, setOpenErrorDialog, onSuccess}) => {
  const rpcParams = new URLSearchParams();
  const rpc = {jsonrpc: "2.0", method, id: method, params};
  rpcParams.append("request", JSON.stringify(rpc));
  try {
    const json = await fetchJson('/itvs-site/jsonrpc', {
      method: "post",
      headers : {
        'Accept': 'application/json',
      },
      body: rpcParams,
    }, 8000);
    if (json.error) {
      setErrorMessage(json.error.message);
      setOpenErrorDialog(true); 
    } else if (onSuccess) {
      onSuccess(json.result);
    }
  } catch (err) {
    console.error(err);
    setErrorMessage(`${method} failed: ${err}`);
    setOpenErrorDialog(true);
  }
};